import { render, staticRenderFns } from "./ESGDataLogDetails.vue?vue&type=template&id=01319d43"
import script from "./ESGDataLogDetails.vue?vue&type=script&lang=js"
export * from "./ESGDataLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports